import styled from "styled-components";
import { device } from "../../globalAssets/breakpoints";
import { desktop } from "../../globalAssets/fontsize";
export const Text = styled.h4`
  color: ${(props) => props.theme.color};
`;
export const UniCard = styled.div`
  padding: 10px 12px;
  margin: 15px;
  border-radius: 10px;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  /* border-left: ${(props) => `2px solid ${props.theme.primaryColor}`}; */
  /* transition: all ease-in 0.2s; */
  cursor: pointer;
  width: 350px;
  height: fit-content;
  /* display: flex; */
  & > h1 {
    margin: 0;
    color: ${(props) => props.theme.color};
    font-size: ${desktop.normal};
    font-weight: 400;
    span {
      font-weight: 500;
      font-size: ${desktop.medium};
    }
  }
  :hover {
    transform: scale(1.01);
  }
`;

export const UniAvatar = styled.div`
  width: 37px;
  height: 37px;
  border-radius: 50%;
  display: grid;
  margin-right: 10px;
  place-items: center;
  color: white;
  background-color: ${(props) => props.theme.tint};
`;

export const SchoolDetailsCard = styled.div`
  padding: 5px 10px;
  margin-bottom: 10px;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  & > h2 {
    font-size: 16px;
    font-weight: 500;
    color: ${(props) => props.theme.color};
    border-bottom: ${(props) => `1px solid ${props.theme.primaryColor}`};
  }
  & > h3 {
    font-size: 14px;
    color: ${(props) => props.theme.color};
    font-weight: 600;
    & > a {
      text-decoration-color: ${(props) => props.theme.primaryColor};
    }
  }
  @media ${device.laptop} {
    padding: 0.5vw 1vw;

    & > h2 {
      font-size: ${desktop.medium};
    }
    & > h3 {
      font-size: ${desktop.normal};
    }
  }
`;
